<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-users"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ modoEdicao ? texts.titulo_edicao : texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <!-- Fechada sem vaga: seria o atalho que contorna o gate do botão (ver cadastroBloqueado) -->
    <p-tabPanel [disabled]="cadastroBloqueado">
      <ng-template pTemplate="header">
        <i class="pi pi-user-plus tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <!-- Banner de edicao -->
        <div class="editing-banner" *ngIf="modoEdicao">
          <i class="pi pi-pencil"></i>
          <span>{{ texts.titulo_edicao }}</span>
        </div>
        <div class="card-header">
          <div class="card-header-icon">
            <i [class]="modoEdicao ? 'pi pi-user-edit' : 'pi pi-user-plus'"></i>
          </div>
          <span class="card-header-title">{{ texts.dados_do_usuario }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <!-- Nome (half) -->
            <div class="form-field half">
              <label class="form-label" for="campo-nome">
                {{ labels.nome }} <span class="required" aria-hidden="true">*</span>
              </label>
              <input
                id="campo-nome"
                type="text"
                pInputText
                [placeholder]="placeholders.nome_do_usuario"
                [(ngModel)]="form.nome"
                [class.error-field]="isFormSubmitted && !form.nome"
                required
                aria-required="true"
                [attr.aria-invalid]="isFormSubmitted && !form.nome ? 'true' : null"
                class="w-full" />
            </div>
            <!-- E-mail (half) -->
            <div class="form-field half">
              <label class="form-label" for="campo-email">
                {{ labels.e_mail }} <span class="required" aria-hidden="true">*</span>
              </label>
              <input
                id="campo-email"
                type="email"
                pInputText
                [placeholder]="placeholders.e_mail"
                [(ngModel)]="form.email"
                autocomplete="off"
                [class.error-field]="isFormSubmitted && !form.email"
                required
                aria-required="true"
                [attr.aria-invalid]="isFormSubmitted && !form.email ? 'true' : null"
                class="w-full" />
            </div>
            <!-- Senha (half) — obrigatória no cadastro; ocultada na edição (usar botão pi-key na tabela) -->
            <div class="form-field half" *ngIf="!modoEdicao">
              <label class="form-label" for="campo-senha">
                {{ labels.senha }} <span class="required" aria-hidden="true">*</span>
              </label>
              <input
                id="campo-senha"
                type="password"
                pInputText
                [placeholder]="placeholders.senha"
                [(ngModel)]="form.senha"
                autocomplete="new-password"
                [class.error-field]="isFormSubmitted && !form.senha"
                required
                aria-required="true"
                [attr.aria-invalid]="isFormSubmitted && !form.senha ? 'true' : null"
                class="w-full" />
            </div>

            <!-- Grupo de Privilegio -->
            <div class="form-field" [ngClass]="modoEdicao ? 'third' : 'half'">
              <label class="form-label" for="campo-grupo">{{ labels.grupo_de_privilegio }} <span class="required" aria-hidden="true">*</span></label>
              <p-dropdown
                inputId="campo-grupo"
                [options]="grupoDePrivilegioList"
                [(ngModel)]="form.grupoDePrivilegio"
                optionLabel="label"
                [placeholder]="placeholders.selecione_um_grupo"
                appendTo="body">
              </p-dropdown>
            </div>
            <!-- Telefone -->
            <div class="form-field" [ngClass]="modoEdicao ? 'third' : 'half'">
              <app-phone-input
                [(telefone)]="form.telefone"
                [(ddi)]="paisSelecionado"
                [label]="labels.telefone">
              </app-phone-input>
            </div>

            <!-- Status Ativo — somente na edição -->
            <div class="form-field" [ngClass]="modoEdicao ? 'third' : 'half'" *ngIf="modoEdicao">
              <label class="form-label">{{ labels.status }}</label>
              <div class="flex align-items-center gap-2 mt-1">
                <p-inputSwitch [(ngModel)]="form.ativo" inputId="campo-ativo"></p-inputSwitch>
                <label for="campo-ativo" class="cursor-pointer">
                  {{ form.ativo ? ('usuario.labels.ativo' | translate) : ('usuario.labels.inativo' | translate) }}
                </label>
              </div>
            </div>

            <!-- Foto (full) — modo edição e cadastro -->
            <div class="form-field full">
              <label class="form-label" for="campo-foto">{{ labels.foto }}</label>
              <div class="foto-upload-container">
                <img *ngIf="form.imagem"
                  [src]="'data:image/jpeg;base64,' + form.imagem"
                  alt="Foto do usuário"
                  class="foto-preview" />
                <span *ngIf="!form.imagem" class="foto-placeholder">
                  <i class="pi pi-user"></i>
                </span>
                <label for="campo-foto" class="foto-upload-btn p-button p-button-outlined p-button-sm">
                  <i class="pi pi-upload mr-1"></i>
                  {{ labels.foto }}
                </label>
                <input
                  id="campo-foto"
                  type="file"
                  accept="image/*"
                  style="display:none"
                  (change)="onFotoSelecionada($event)" />
              </div>
            </div>
          </div>
          <!-- Botoes de Acao -->
          <div class="actions-container mt-3">
            <button *ngIf="modoEdicao"
              pButton [label]="botoes.cancelar_edicao" icon="pi pi-times"
              class="p-button-secondary"
              (click)="cancelarEdicao()">
            </button>
            <button pButton
              [label]="modoEdicao ? botoes.salvar : botoes.adicionar"
              [icon]="modoEdicao ? 'pi pi-save' : 'pi pi-check'"
              (click)="submit()"
              [disabled]="submitting" [loading]="submitting"
              class="btn-primary">
            </button>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.tabela_de_usuarios }}</span>
          <div class="card-header-actions">
            <!-- Vagas do plano: "2 de 3 usuários". O número é o que evita o usuário
                 descobrir o limite só ao levar erro no cadastro. -->
            <span *ngIf="limiteUsuarios" class="usuarios-limite-chip"
                  [class.usuarios-limite-chip--cheio]="semVagasDisponiveis">
              <i class="pi pi-users" aria-hidden="true"></i>
              {{ 'usuario.contratacao.vagas' | translate:{
                   usados: limiteUsuarios.usuariosAtivos, total: limiteUsuarios.limite
                 } }}
            </span>
            <button *ngIf="limiteUsuarios?.podeContratarUsuarios" pButton
              [label]="'usuario.contratacao.contratar' | translate"
              icon="pi pi-user-plus"
              class="p-button-outlined btn-sm"
              (click)="abrirDialogContratacao()">
            </button>
            <!-- Sem vagas e sem como comprar avulso (plano gratuito, ESPECIAL ou vencido):
                 a saída é o plano. Sem este atalho a tela avisaria que acabou e não ofereceria
                 caminho nenhum. -->
            <button *ngIf="mostrarAtalhoParaPlanos" pButton
              [label]="'usuario.contratacao.contratar_plano' | translate"
              icon="pi pi-star"
              class="p-button-outlined btn-sm"
              (click)="irParaPlanos(true)">
            </button>
            <!-- Contador não tem autoatendimento, e mandá-lo para /planos descartaria as vagas
                 concedidas na troca de plano. O caminho é o suporte. -->
            <button *ngIf="mostrarContatoSuporte" pButton
              [label]="'usuario.contratacao.suporte_botao' | translate"
              icon="pi pi-headphones"
              class="p-button-outlined btn-sm"
              (click)="abrirDialogSuporte()">
            </button>
            <button pButton [label]="texts.novo_usuario"
              icon="pi pi-plus" (click)="novoUsuario()" class="btn-primary btn-sm">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="filterName"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <!-- TODO: update otimista local -->
          <p-table [value]="usuarios" [loading]="loading"
            dataKey="id"
            [customSort]="true"
            (sortFunction)="customSort($event)"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 5%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('imagem')" style="width: 8%">{{ labels.imagem }}</th>
                <th [hidden]="!isColumnVisible('username')" pSortableColumn="username" style="width: 20%">
                  {{ labels.username }}<p-sortIcon [field]="'username'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('email')" pSortableColumn="email" style="width: 25%">
                  {{ labels.e_mail }}<p-sortIcon [field]="'email'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('grupo')" pSortableColumn="grupoDePrivilegio.nome" style="width: 22%">
                  {{ labels.grupo_de_privilegio }}<p-sortIcon [field]="'grupoDePrivilegio.nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-usuario>
              <tr>
                <td [hidden]="!isColumnVisible('id')">
                  <span class="id-badge">{{ usuario.id }}</span>
                </td>
                <td [hidden]="!isColumnVisible('imagem')">
                  <img *ngIf="usuario.imagem"
                    [src]="'data:image/jpeg;base64,' + usuario.imagem"
                    alt=""
                    class="product-image"
                    (error)="usuario.imagem = null" />
                  <span *ngIf="!usuario.imagem" class="avatar-placeholder">
                    {{ usuario.username?.charAt(0)?.toUpperCase() }}
                  </span>
                </td>
                <td [hidden]="!isColumnVisible('username')">{{ usuario.username }}</td>
                <td [hidden]="!isColumnVisible('email')">{{ usuario.email }}</td>
                <td [hidden]="!isColumnVisible('grupo')">{{ usuario.grupoDePrivilegio?.nome }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm action-btn edit-btn"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    [attr.aria-label]="tooltips.editar"
                    (click)="editarUsuario(usuario.id)">
                  </button>
                  <button pButton icon="pi pi-key"
                    class="p-button-text p-button-rounded p-button-sm action-btn edit-btn"
                    [pTooltip]="tooltips.alterar_senha" tooltipPosition="top"
                    [attr.aria-label]="tooltips.alterar_senha"
                    (click)="abrirDialogoSenha(usuario.id)">
                  </button>
                  <button pButton
                    [icon]="usuario.ativo === false ? 'pi pi-eye-slash' : 'pi pi-eye'"
                    class="p-button-text p-button-rounded p-button-sm action-btn edit-btn"
                    [pTooltip]="usuario.ativo === false ? tooltips.ativar : tooltips.inativar"
                    tooltipPosition="top"
                    [attr.aria-label]="usuario.ativo === false ? tooltips.ativar : tooltips.inativar"
                    [disabled]="statusEmProgresso.has(usuario.id)"
                    (click)="alternarStatusUsuario(usuario)">
                  </button>
                  <button pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm action-btn delete-btn"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    [attr.aria-label]="tooltips.excluir"
                    (click)="deletarUsuario(usuario.id, $any($event.currentTarget))">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_usuario }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" [closeOnEscape]="true"
  styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }"
  (onHide)="onDeleteDialogHide()">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Dialogo de Alteracao de Senha (Divergência 4) -->
<p-dialog [(visible)]="senhaDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" [closeOnEscape]="true"
  styleClass="dialog-wave-redesign" [style]="{ width: '28rem' }"
  (onHide)="fecharDialogoSenha()">
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-key" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.alterar_senha_titulo }}</h2>
        <p>{{ texts.alterar_senha_subtitulo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="field">
      <label for="campo-senha-nova">
        {{ texts.alterar_senha_label_nova }} <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <input
        id="campo-senha-nova"
        type="password"
        pInputText
        [placeholder]="texts.alterar_senha_placeholder_nova"
        [(ngModel)]="senhaForm.senhaNova"
        autocomplete="new-password"
        [class.error-field]="senhaFormSubmitted && !senhaForm.senhaNova"
        class="w-full" />
    </div>
    <div class="field">
      <label for="campo-confirmacao-senha">
        {{ texts.alterar_senha_label_confirmar }} <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <input
        id="campo-confirmacao-senha"
        type="password"
        pInputText
        [placeholder]="texts.alterar_senha_placeholder_confirmar"
        [(ngModel)]="senhaForm.confirmacaoSenha"
        autocomplete="new-password"
        [class.error-field]="senhaFormSubmitted && !senhaForm.confirmacaoSenha"
        class="w-full" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fecharDialogoSenha()">
      {{ botoes.fechar_esc }}
    </button>
    <button pButton icon="pi pi-check" class="btn-primary" (click)="confirmarAlteracaoSenha()">
      {{ botoes.guardar_ctrl_s }}
    </button>
  </ng-template>
</p-dialog>

<!-- ===================================================================== -->
<!-- DIALOG: Contratar usuários de acesso adicionais                        -->
<!-- ===================================================================== -->
<p-dialog [(visible)]="contratarDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" [closeOnEscape]="true"
  styleClass="dialog-wave-redesign" [style]="{ width: '32rem' }"
  (onHide)="fecharDialogContratacao()">
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-user-plus" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'usuario.contratacao.titulo' | translate }}</h2>
        <p>{{ 'usuario.contratacao.subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <!-- Escolha da quantidade: some assim que a cobrança é gerada (QR ou cartão), para não
         mudar o valor de algo que já está sendo pago. -->
    <ng-container *ngIf="!aguardandoPagamentoContratacao">
      <p class="contratacao-ajuda">
        {{ 'usuario.contratacao.explicacao' | translate:{ meses: limiteUsuarios?.mesesRestantes || 0 } }}
      </p>

      <div class="contratacao-controle">
        <button pButton type="button" icon="pi pi-minus"
                class="p-button-rounded p-button-outlined"
                [disabled]="quantidadeParaContratar <= 1"
                [attr.aria-label]="'usuario.contratacao.remover' | translate"
                (click)="alterarQuantidadeParaContratar(-1)"></button>
        <span class="contratacao-quantidade">{{ quantidadeParaContratar }}</span>
        <button pButton type="button" icon="pi pi-plus"
                class="p-button-rounded p-button-outlined"
                [disabled]="quantidadeParaContratar >= MAX_USUARIOS_CONTRATACAO"
                [attr.aria-label]="'usuario.contratacao.adicionar' | translate"
                (click)="alterarQuantidadeParaContratar(1)"></button>
      </div>

      <div *ngIf="simulacaoContratacao" class="contratacao-resumo">
        <div class="contratacao-resumo__linha">
          <span>{{ 'usuario.contratacao.por_usuario_mes' | translate }}</span>
          <span>{{ simulacaoContratacao.valorUnitarioMensal | currency:moedaPlano:'symbol-narrow':'1.0-0':localePlano }}</span>
        </div>
        <div class="contratacao-resumo__linha">
          <span>{{ 'usuario.contratacao.meses_restantes' | translate }}</span>
          <span>{{ simulacaoContratacao.meses }}</span>
        </div>
        <div *ngIf="simulacaoContratacao.valorDesconto > 0" class="contratacao-resumo__linha contratacao-resumo__linha--desconto">
          <span>{{ 'usuario.contratacao.desconto' | translate:{ percentual: simulacaoContratacao.porcentagemDesconto } }}</span>
          <span>- {{ simulacaoContratacao.valorDesconto | currency:moedaPlano:'symbol-narrow':'1.0-0':localePlano }}</span>
        </div>
        <div class="contratacao-resumo__linha contratacao-resumo__linha--total">
          <span>{{ 'usuario.contratacao.total' | translate }}</span>
          <strong>{{ simulacaoContratacao.valorTotal | currency:moedaPlano:'symbol-narrow':'1.0-0':localePlano }}</strong>
        </div>
      </div>

      <!-- Botões de pagamento no CORPO, e não no rodapé: são dois rótulos longos que, ao lado
           do "Fechar", não cabiam na largura do diálogo e saíam cortados por cima do ícone.
           Mesmo arranjo do diálogo de pagamento da tela de planos. -->
      <div class="contratacao-botoes">
        <!-- `label` (e não texto projetado): o PrimeNG só envolve o rótulo em .p-button-label
             quando ele vem por binding, e é essa classe que dá o espaçamento do ícone. Com
             texto projetado o ícone encostava na primeira letra. -->
        <button pButton icon="pi pi-qrcode"
                [label]="'usuario.contratacao.pagar_com_qr' | translate"
                class="p-button-outlined"
                [loading]="gerandoQrContratacao"
                [disabled]="carregandoSimulacao || !simulacaoContratacao || gerandoPagamentoContratacao"
                (click)="gerarQrContratacao()">
        </button>
        <button pButton icon="pi pi-credit-card"
                [label]="'usuario.contratacao.pagar_com_cartao' | translate"
                class="btn-primary"
                [loading]="gerandoLinkTpagoContratacao"
                [disabled]="carregandoSimulacao || !simulacaoContratacao || gerandoPagamentoContratacao"
                (click)="gerarLinkTpagoContratacao()">
        </button>
      </div>
    </ng-container>

    <!-- QR gerado: a tela fica esperando o callback confirmar o pagamento. -->
    <div *ngIf="urlQrContratacao" class="contratacao-qr">
      <img [src]="urlQrContratacao" [alt]="'usuario.contratacao.qrcode_alt' | translate" />
      <p class="contratacao-qr__instrucao">
        {{ 'usuario.contratacao.aguardando_pagamento' | translate }}
      </p>
      <p-progressSpinner styleClass="contratacao-qr__spinner" strokeWidth="4"></p-progressSpinner>
    </div>

    <!-- Cartão: o pagamento acontece na aba do T-Pago; aqui só esperamos a confirmação. -->
    <div *ngIf="aguardandoPagamentoTpago" class="contratacao-qr">
      <i class="pi pi-credit-card contratacao-qr__icone" aria-hidden="true"></i>
      <p class="contratacao-qr__instrucao">
        {{ 'usuario.contratacao.aguardando_pagamento_cartao' | translate }}
      </p>
      <p-progressSpinner styleClass="contratacao-qr__spinner" strokeWidth="4"></p-progressSpinner>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fecharDialogContratacao()">
      {{ botoes.fechar_esc }}
    </button>
  </ng-template>
</p-dialog>

<p-toast />

<!-- Contato do suporte para quem não tem autoatendimento (contador).
     `closable` fica no default (true), ao contrário dos outros diálogos desta tela: com
     `[closable]="false"` o PrimeNG torna `closeOnEscape` e `dismissableMask` INERTES e o rótulo
     "Fechar (Esc)" mentiria. Aqui não há estado a proteger. Com `showHeader` false, `closable`
     não desenha nenhum "X" — o visual não muda. -->
<p-dialog [(visible)]="suporteDialogVisible" [showHeader]="false" [modal]="true"
  [draggable]="false" [closeOnEscape]="true" [dismissableMask]="true"
  styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }"
  (onHide)="fecharDialogSuporte()">
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-headphones" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'usuario.contratacao.suporte_titulo' | translate }}</h2>
        <p>{{ 'usuario.contratacao.suporte_subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="contratacao-ajuda">
      {{ 'usuario.contratacao.suporte_explicacao' | translate }}
    </p>
    <p *ngIf="limiteUsuarios" class="contratacao-ajuda">
      {{ 'usuario.contratacao.suporte_vagas' | translate:{ total: limiteUsuarios.limite } }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fecharDialogSuporte()">
      {{ botoes.fechar_esc }}
    </button>
    <button pButton icon="pi pi-whatsapp" class="btn-primary"
      [label]="'usuario.contratacao.suporte_whatsapp' | translate"
      (click)="abrirWhatsappSuporte()">
    </button>
  </ng-template>
</p-dialog>
